import { Env, getAssetPath } from '@stencil/core';
// Since all versions are matching across all packages we can simply take our own version (for now)
import assetsPackageInfo from '../../../package.json';

export const getIconUrl = (libraryName: string, iconName: string): string => {
	const isDev = Env.DEV === 'true';
	const isThemeIcon = libraryName.startsWith('theme-');

	let localPath: string;
	if (isThemeIcon) {
		const themeName = libraryName.substring(6);
		localPath = `theme-icons/${themeName}/${iconName}.svg`;
	} else {
		localPath = `global-icons/${libraryName}/${iconName}.svg`;
	}

	if (isDev) {
		// On a dev environment, use local path
		return getAssetPath(`../../assets/${localPath}`);
	}

	// On a non-dev environment, use CDN
	return `https://zds-cdn.zig365.nl/@zig-design-system-assets/${assetsPackageInfo.version}/${localPath}`;
};
